import React, { useState} from "react";
import { createPortal } from "react-dom";
import { v4 as uuidv4 } from "uuid";
import toast from "react-hot-toast";
import { appInsights } from "../../services/analytics/appInsights";
import { useMsal } from "@azure/msal-react";

const AddProjectModal = ({ isOpen, onClose, onSubmit }) => {
  const [projectNumber, setProjectNumber] = useState("");
  const [projectName, setProjectName] = useState("");
  const [customer, setCustomer] = useState("");
  const [engineer, setEngineer] = useState("");
  const [architect, setArchitect] = useState("");

  const { accounts } = useMsal();
  const userName = accounts && accounts[0] ? accounts[0].name : "Unknown";

  const handleSubmit = async () => {
    // Validate required fields
    if (!projectNumber.trim()) {
      toast.error("Project Number is required.");
      return;
    }
    if (!projectName.trim()) {
      toast.error("Project Name is required.");
      return;
    }

    const newProject = {
      id: uuidv4(), // Use uuidv4 to generate a unique ID
      job_number: projectNumber,
      job_name: projectName,
      customer,
      engineer,
      architect,
    };
    try {
      await onSubmit(newProject);
      
      // Track the creation of a new project
      appInsights.trackEvent({
        name: 'NewProjectCreated',
        properties: {
          projectNumber: projectNumber,
          projectName: projectName,
          user: userName,
          customer: customer || 'Not specified',
          engineer: engineer || 'Not specified',
          architect: architect || 'Not specified'
        }
      });
      
      toast.success("Project added successfully!");
      onClose();
      setProjectNumber("");
      setProjectName("");
      setCustomer("");
      setEngineer("");
      setArchitect("");
    } catch (error) {
      toast.error("Failed to add project.");
      console.error("Failed to add project", error);
    }
  };

  if (!isOpen) {
    return null;
  }

  // Use React Portal to render the modal at the document root
  return createPortal(
    <div
      className="fixed inset-0 z-[9999] flex items-center justify-center"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 9999,
      }}
    >
      <div
        className="absolute inset-0 bg-gray-800 bg-opacity-50"
        onClick={onClose}
      ></div>
      <div className="relative bg-white p-8 rounded-lg shadow-lg w-full max-w-lg z-10">
        <h2 className="text-xl font-bold mb-4">Add New Project</h2>
        <div className="space-y-4">
          <div>
            <label className="block font-medium text-gray-700">
              Project Number *
            </label>
            <input
              type="text"
              value={projectNumber}
              onChange={(e) => setProjectNumber(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700">
              Project Name *
            </label>
            <input
              type="text"
              value={projectName}
              onChange={(e) => setProjectName(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700">Customer</label>
            <input
              type="text"
              value={customer}
              onChange={(e) => setCustomer(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700">Engineer</label>
            <input
              type="text"
              value={engineer}
              onChange={(e) => setEngineer(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>
          <div>
            <label className="block font-medium text-gray-700">Architect</label>
            <input
              type="text"
              value={architect}
              onChange={(e) => setArchitect(e.target.value)}
              className="mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm"
            />
          </div>
        </div>
        <div className="mt-6 flex justify-start gap-8">
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-indigo-600 text-white rounded-lg"
          >
            Create Project
          </button>
          <button
            onClick={onClose}
            className="px-4 py-2 bg-[#DC2626] text-white rounded-lg"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default AddProjectModal;
